import SettlementRuns from "../js/components/settlements/SettlementRuns.react";

export default SettlementRuns;
